module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-917.141b3fb0.jpg";